import { IValidator } from "../../../Validation/IValidator";
import { EntryModel, HoursOfOperationDisplayType, HoursEntryModel } from "@truckdown/locations";
import { getTimeRange, rangesOverlap } from '../../../utilities';
interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class TimeEntryValidator {
    private _allEntries: { [key: string]: HoursEntryModel };
    private _dayKey: string;
    private _entryIndex: number;
    private _entryType: HoursOfOperationDisplayType;
    private _validators: IPropertyValidator[];

    public errors: { [key: string]: string } = {};

    constructor(
        allEntries: { [key: string]: HoursEntryModel },
        dayKey: string,
        entryIndex: number,
        entryType: HoursOfOperationDisplayType 
    ) {
        this._allEntries = allEntries;
        this._dayKey = dayKey;
        this._entryIndex = entryIndex;
        this._entryType = entryType;
        this._validators = this.getValidators();
    }

   
    private getValidators(): IPropertyValidator[] {
   
        const is24h = this._allEntries[this._dayKey]?.afterHours24;
        let allDayEntries = this._allEntries[this._dayKey]?.entries ?? [];

        if (is24h) {
            // Remove all entries of type after hours
            allDayEntries = allDayEntries.filter(e => e.type !== HoursOfOperationDisplayType.AfterHours);
        }
  
        const entry = allDayEntries.filter(e => e.type === this._entryType)[this._entryIndex];
        const keyPrefix = `${this._dayKey}-${this._entryType}-${this._entryIndex}`;

        if (!entry) return [];

        return [
            {
                key: `startTime-${keyPrefix}`,
                message: () => "Start time is required.",
                validator: () => !!entry.startTime
            },
            {
                key: `endTime-${keyPrefix}`,
                message: () => "End time is required.",
                validator: () => !!entry.endTime
            },
            {
                key: `range-${keyPrefix}`,
                message: () => "Start and end time cannot be the same.",
                validator: () => entry.startTime !== entry.endTime || (entry.startTime == "00:00" && entry.endTime == "00:00")
            },
            {
                key: `overlap-${keyPrefix}`,
                message: () => "This time overlaps with another entry.",
                validator: () => {
                    if (!entry.startTime || !entry.endTime || entry.type === HoursOfOperationDisplayType.Unknown) return true;

                    const currentRange = getTimeRange(entry);
                    let seen = -1;

                    return !allDayEntries.some((other) => {
                        if (other.type === this._entryType) {
                            seen++;
                            if (seen === this._entryIndex) return false;
                        }

                        if (other.type === HoursOfOperationDisplayType.Unknown) return false;

                        const otherRange = getTimeRange(other);
                        return rangesOverlap(currentRange, otherRange);
                    });
                }
            }
        ];
    }

    public validate(key?: string): boolean {
        if (key) {
            const v = this._validators.find(v => v.key === key);
            if (!v) return true;

            const valid = v.validator();
            if (!valid) {
                this.errors[key] = v.message();
            } else {
                delete this.errors[key];
            }
            return valid;
        } else {
            let allValid = true;
            for (const v of this._validators) {
                const valid = v.validator();
                if (!valid) {
                    this.errors[v.key] = v.message();
                    allValid = false;
                } else {
                    delete this.errors[v.key];
                }
            }
            return allValid;
        }
    }

    public reset() {
        this.errors = {};
    }
}